import React from "react";
import ImageGallery from "../components/ImageGallery";

function MariagePage() {
  return <ImageGallery category="mariage" />;
}

export default MariagePage;
